var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _g2, _rect, _rect2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadDocuments = function SvgUploadDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 122,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D7F1F9",
    d: "M173.603 118.907H13.01c-1.241 0-2.173.736-2.173 1.547 0 .883 1.035 1.546 2.173 1.546H173.5c1.242 0 2.173-.736 2.173-1.546.103-.811-.931-1.547-2.07-1.547Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M142.696.898H35.393a10.887 10.887 0 0 0-10.918 10.92V85.37a10.887 10.887 0 0 0 10.918 10.92h107.303a10.888 10.888 0 0 0 10.919-10.92V11.817c0-5.955-4.864-10.919-10.919-10.919Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7F1F9",
    d: "M34.996 68.099c-2.382 0-4.367-1.986-4.367-4.368l.298-52.013c0-2.382 1.985-4.368 4.367-4.368h107.6c2.383 0 4.368 1.986 4.368 4.368l-.298 52.112c0 2.383-1.985 4.368-4.367 4.368h-107.6v-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCF3FA",
    d: "M24.537 75.596v9.891c0 6.034 4.86 10.88 10.91 10.88h107.225c6.05 0 10.91-4.846 10.91-10.88v-9.89H24.537Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDE6EF",
    d: "M108.064 96.367H70.057v14.584h38.007V96.367Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4D3DD",
    d: "M108.064 96.367H70.057v4.42h38.007v-4.42Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9F2FA",
    d: "M116.149 110.95H61.877c-5.297 0-9.495 4.242-9.495 9.371v1.677h73.362v-1.677c0-5.228-4.298-9.371-9.595-9.371Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M93.484 86.644c0 2.69-2.073 4.862-4.64 4.862-2.567 0-4.64-2.172-4.64-4.862 0-2.689 2.073-4.861 4.64-4.861 2.567 0 4.64 2.275 4.64 4.861Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#upload_documents_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M129.17 15.05H47.19c-1.479 0-2.761 1.148-2.761 2.678v3.923c0 1.435 1.183 2.68 2.762 2.68h81.979c1.48 0 2.762-1.149 2.762-2.68V17.73c0-1.531-1.282-2.68-2.762-2.68Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.804 55.945h-32.28c-.597 0-1.095.523-1.095 1.15v1.676c0 .628.498 1.151 1.096 1.151h32.279c.598 0 1.096-.523 1.096-1.151v-1.675c0-.733-.498-1.151-1.096-1.151Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M61.794 21.645a1.489 1.489 0 1 0 0-2.978 1.489 1.489 0 0 0 0 2.978ZM72.416 21.645a1.489 1.489 0 1 0 0-2.978 1.489 1.489 0 0 0 0 2.978ZM82.937 21.645a1.489 1.489 0 1 0 0-2.978 1.489 1.489 0 0 0 0 2.978ZM93.562 21.645a1.489 1.489 0 1 0 0-2.978 1.489 1.489 0 0 0 0 2.978ZM104.076 21.645a1.489 1.489 0 1 0 0-2.977 1.489 1.489 0 0 0 0 2.977ZM114.698 21.645a1.489 1.489 0 1 0 0-2.977 1.489 1.489 0 0 0 0 2.977Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#upload_documents_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#upload_documents_svg__c)",
    d: "M17.882 57.651c8.771 0 15.882-7.11 15.882-15.882 0-8.771-7.11-15.881-15.882-15.881C9.11 25.887 2 32.998 2 41.769c0 8.772 7.11 15.882 15.882 15.882Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.09,
    height: 17.04,
    x: 15.63,
    y: 33.615,
    fill: "#F7FBFD",
    rx: 2.045
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.09,
    height: 17.04,
    x: 9.153,
    y: 44.18,
    fill: "#F7FBFD",
    rx: 2.045,
    transform: "rotate(-90 9.153 44.18)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#upload_documents_svg__d)",
    d: "m56.842 34.316-.612-4.06h-8.988c-1.353 0-2.427 1.103-2.427 2.456v16.995a2.417 2.417 0 0 0 2.427 2.434h12.229a2.439 2.439 0 0 0 2.439-2.44V36.21l-5.068-1.893Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m56.23 30.262 5.663 5.948h-3.77a1.892 1.892 0 0 1-1.893-1.894v-4.054Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.015 43.008h-7.256a.559.559 0 0 0-.557.557c0 .307.25.557.557.557h7.256c.306 0 .557-.25.557-.557a.555.555 0 0 0-.557-.557ZM48.76 41.338h5.64c.306 0 .557-.251.557-.557a.559.559 0 0 0-.557-.557h-5.64a.559.559 0 0 0-.558.557c0 .306.25.557.557.557ZM54.183 45.848h-5.424a.559.559 0 0 0-.557.557c0 .306.25.557.557.557h5.424c.306 0 .557-.251.557-.557a.559.559 0 0 0-.557-.557Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#upload_documents_svg__e)",
    d: "m80.052 34.316-.612-4.06h-8.988c-1.353 0-2.428 1.103-2.428 2.456v16.995a2.417 2.417 0 0 0 2.428 2.434h12.229a2.439 2.439 0 0 0 2.439-2.44V36.21l-5.068-1.893Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m79.44 30.262 5.663 5.948h-3.77a1.892 1.892 0 0 1-1.893-1.894v-4.054Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.224 43.008H71.97a.559.559 0 0 0-.557.557c0 .307.25.557.556.557h7.256c.306 0 .557-.25.557-.557a.555.555 0 0 0-.557-.557ZM71.969 41.338h5.64c.307 0 .557-.251.557-.557a.558.558 0 0 0-.557-.557h-5.64a.558.558 0 0 0-.557.557c0 .306.25.557.556.557ZM77.392 45.848H71.97a.559.559 0 0 0-.557.557c0 .306.25.557.556.557h5.424c.306 0 .557-.251.557-.557a.559.559 0 0 0-.557-.557Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#upload_documents_svg__f)",
    d: "m103.262 34.316-.612-4.06h-8.988c-1.353 0-2.428 1.103-2.428 2.456v16.995a2.417 2.417 0 0 0 2.428 2.434h12.229a2.439 2.439 0 0 0 2.439-2.44V36.21l-5.068-1.893Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m102.649 30.262 5.664 5.948h-3.77a1.892 1.892 0 0 1-1.894-1.894v-4.054Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102.434 43.008h-7.256a.559.559 0 0 0-.557.557c0 .306.25.557.557.557h7.256c.306 0 .557-.25.557-.557a.555.555 0 0 0-.557-.557ZM95.178 41.337h5.641c.306 0 .557-.25.557-.557a.559.559 0 0 0-.557-.556h-5.641a.559.559 0 0 0-.557.556c0 .307.25.557.557.557ZM100.602 45.848h-5.424a.559.559 0 0 0-.557.556c0 .307.25.557.557.557h5.424c.306 0 .557-.25.557-.557a.559.559 0 0 0-.557-.556Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#upload_documents_svg__g)",
    d: "m126.472 34.316-.612-4.06h-8.988c-1.353 0-2.428 1.103-2.428 2.456v16.995a2.417 2.417 0 0 0 2.428 2.434h12.229a2.439 2.439 0 0 0 2.439-2.44V36.21l-5.068-1.893Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m125.86 30.262 5.663 5.948h-3.77a1.891 1.891 0 0 1-1.893-1.894v-4.054Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M125.645 43.008h-7.256a.558.558 0 0 0 0 1.114h7.256c.306 0 .557-.25.557-.557a.555.555 0 0 0-.557-.557ZM118.389 41.338h5.641a.558.558 0 0 0 0-1.114h-5.641a.558.558 0 0 0 0 1.114ZM123.813 45.848h-5.424a.558.558 0 0 0 0 1.114h5.424c.306 0 .557-.251.557-.557a.559.559 0 0 0-.557-.557Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#004E82",
    d: "M137.829 118.128v3.772h-10.224c-.596 0-.894-.794-.397-1.191 1.191-.894 3.275-2.085 6.253-2.581h4.368ZM156.39 118.128v3.772h-10.224c-.596 0-.894-.794-.397-1.191 1.191-.894 3.275-2.085 6.253-2.581h4.368Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#004E82",
    d: "M156.481 118.227c-.694-4.864-5.459-37.422-6.452-38.216-.992-.794-8.338 7.643-8.338 7.643.795.794 8.239 25.51 10.423 30.573h4.367Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M137.723 118.227c1.687-5.459 5.558-22.83 10.224-28.885 2.183-2.879 2.183-10.026 2.183-10.026l-12.804 2.581c-2.085 4.268-3.475 29.779-3.772 36.33h4.169Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#64D3B5",
    d: "M146.557 62.242c-.794-2.184-12.209-16.477-12.209-16.477l-4.07 1.886s7.544 13.201 9.43 15.98l6.849-1.389Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#004E82",
    d: "M137.427 51.125s-3.672-1.985-.794-5.955c0 0 1.489 2.481 4.368 1.687 8.933-2.78 9.331 6.551 7.742 9.926-.695 1.49-2.481 2.581-2.878 2.482-.397-.1-2.085-3.375-2.085-3.375l-6.353-4.765Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE27C",
    d: "M137.528 50.928c-.496.695-.397 2.184-.397 3.077 0 2.382 1.588 4.169 3.673 4.169 1.489 0 2.779-.993 3.474-2.283.794.199 1.588-.496 1.886-1.29.298-.894-.099-1.787-.893-2.085-.298-.1-.695.199-.993.298 0 0-1.588-.596-2.184-2.184l-4.566.298Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE27C",
    d: "m145.571 55.394-3.97.794v4.665h3.97v-5.459Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#upload_documents_svg__h)",
    d: "M151.42 80.012s-2.978-16.875-3.375-17.967c-.496-1.092-2.084-1.786-6.65-1.687-2.581 0-11.018-1.49-12.408-2.085-1.39-.595-8.934-9.727-8.934-9.727l-3.474 2.283s7.147 11.216 9.231 12.01c2.184.695 9.827 3.375 9.827 3.375l.298 16.478c0-.199 10.423 4.665 15.485-2.68Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE27C",
    d: "M119.957 48.643s-1.787-4.467-2.283-4.566c-.397-.1-.695 1.688-.695 1.688s-1.688-4.17-2.581-4.269c-.893 0-1.787 4.963 2.382 9.033l3.177-1.886ZM130.976 47.353s-3.276-3.772-2.68-3.97c.596-.1 1.886.893 1.886.893s-2.283-5.161-.794-5.36c1.489-.198 4.367 4.566 4.963 6.75l-3.375 1.687Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload_documents_svg__c",
    x1: 17.882,
    x2: 17.882,
    y1: 25.887,
    y2: 57.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload_documents_svg__d",
    x1: 53.362,
    x2: 53.362,
    y1: 30.257,
    y2: 52.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5183BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload_documents_svg__e",
    x1: 76.572,
    x2: 76.572,
    y1: 30.257,
    y2: 52.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5183BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload_documents_svg__f",
    x1: 99.782,
    x2: 99.782,
    y1: 30.256,
    y2: 52.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D3B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload_documents_svg__g",
    x1: 122.992,
    x2: 122.992,
    y1: 30.257,
    y2: 52.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5183BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload_documents_svg__h",
    x1: 134,
    x2: 134,
    y1: 48.546,
    y2: 84.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "upload_documents_svg__a",
    width: 95.503,
    height: 17.281,
    x: 42.429,
    y: 13.05,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_29742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_91_29742",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "upload_documents_svg__b",
    width: 39.764,
    height: 39.764,
    x: 0,
    y: 23.887,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_29742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_91_29742",
    result: "shape"
  })))));
};
export default SvgUploadDocuments;